<script setup lang="ts"></script>

<template>
  <ion-button v-bind="$attrs" fill="clear" class="base-text-btn normal-case m-0 min-h-fit">
    <slot />
  </ion-button>
</template>

<style scoped lang="scss">
.base-text-btn {
  --padding-end: 2px;
  --padding-start: 2px;
  --padding-top: 2px;
  --padding-bottom: 2px;
  --ripple-color: transparent;

  vertical-align: middle;
  letter-spacing: inherit;
}
</style>
